import '../../static/fonts.css';

const theme = {
  colors: {
    black: '#000',
    white: '#fff',
    grey: '#737373',
    greyLight: '#cdcdcd',
    brand: '#007854',
    brandDark: '#007854',
    button: '#8c263e',
    buttonDark: '#8c263e',
    transparent: 'transparent',
    link: '#0b466e',
    error: '#ee1d1d'
  },
  fonts: {
    regular: 'PT Sans, sans-serif',
    caption: 'PT Sans Caption, sans-serif'
  },
  timings: {
    default: '0.35s cubic-bezier(0.4, 0, 0.2, 1)',
    easeIn: '0.3s cubic-bezier(0, 0, 0, 1)',
    easeOut: '0.3s cubic-bezier(0, 0, 0, 1)'
  },
  shadows: {
    modal: 'rgba(0, 0, 0, 0.3)'
  },
  opacity: {
    default: 1,
    full: 0,
    translucent: 0.4
  },
  zIndexes: {
    modal: 10,
    overlayContent: 10,
    dropdown: 15,
    loader: 20,
    autocomplete: 15
  },
  elem: {
    button: {
      textHover: '#003c9d',
      textActive: '#003c9d',
      disabled: '#cdcdcd'
    },
    checkbox: {
      border: '#979797',
      disabledBorder: '#cdcdcd',
      disabledCheckedBg: '#e8e8e8',
      disabledLabel: '#9b9b9b'
    }
  }
};

export default theme;



// WEBPACK FOOTER //
// ./src/components/theme.js